import { AgencyModel } from './agency.model';
import { RolePolicyModel } from './role-policy.model';
import { TypeOfRole } from './type-of-role.model';

export class RolModel {
  id!: number;
  name!: string;
  agency_id!: number;
  type_of_rol_id!: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  agency?: AgencyModel;
  type?: TypeOfRole;
  policies!: RolePolicyModel[];
  selected?: boolean;

  constructor(data?: Partial<RolModel>) {
    this.policies = [];
    if (data) {
      this.policies = data.policies 
        ? data.policies.map(p => new RolePolicyModel(p)) 
        : [];
      Object.assign(this, data);
    }
  }


 /*addPolicy(policy: RolePolicyModel) {
    if (!this.policies.find(p => p.policy_id === policy.policy_id)) {
      this.policies.push(policy);
    }
  }


 // Remover policy por policy_id
  removePolicy(policyId: number) {
    this.policies = this.policies.filter(p => p.policy_id !== policyId);
  }*/


  getName(): string {
    return this.name;
  }

  // Método útil para verificar permisos
  hasPolicyAccess(policyName: string, permission: string): boolean {
    const policy = this.policies.find(p => p.policy?.name === policyName);
    return policy ? policy.hasPermission(permission) : false;
  }

  /**
   * Input: Recibe:

  policyName: Nombre de la política a verificar (ej: "Usuario")
  permission: Tipo de permiso (ej: "read", "create")

  Proceso:

  Busca en la lista de políticas del rol aquella cuyo policy.name coincida
  Si la encuentra, pegunta si tiene el permiso solicitado
  Si no la encuentra, retorna false
  Output:
  true: Si el rol tiene el permiso para esa política
  false: Si no lo tiene o la política no existe 


  // Uso:
  // console.log(rol.hasPolicyAccess("Usuario", "read")); // true
  // console.log(rol.hasPolicyAccess("Usuario", "create")); // false
  // console.log(rol.hasPolicyAccess("Reportes", "read")); // false (no existe la política)
  */

  getFormattedLastUpdate(): string | null {
    if (!this.updated_at) return null;
    const date = new Date(this.updated_at);
    //return date.toLocaleString();
     return date.toLocaleString('en-EN', {
      year: 'numeric',
      month: 'long',   // 'numeric', '2-digit', 'short', 'long'
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      //second: '2-digit',
    });
  }

  getFormattedCreateDate(): string | null {
    if (!this.created_at) return null;
    const date = new Date(this.created_at);
    //return date.toLocaleString();
     return date.toLocaleString('en-EN', {
      year: 'numeric',
      month: 'long',   // 'numeric', '2-digit', 'short', 'long'
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      //second: '2-digit',
      });
  }

}